export * from './arrow-left'
export * from './arrow-left-simple'
export * from './arrow-right'
export * from './arrow-right-simple'
export * from './magnifying-glass'
export * from './pin-point'
export * from './plus'
export * from './share'
export * from './telephone'
